__turbopack_context__.v({
  "actions": "invite-module___P1A2q__actions",
  "body": "invite-module___P1A2q__body",
  "card": "invite-module___P1A2q__card",
  "error": "invite-module___P1A2q__error",
  "link": "invite-module___P1A2q__link",
  "links": "invite-module___P1A2q__links",
  "title": "invite-module___P1A2q__title",
  "wrap": "invite-module___P1A2q__wrap",
});
